document.addEventListener('DOMContentLoaded', function () {
  const navLinks = document.querySelectorAll('a[href^="#ks-world-"]');
  const floatingNav = document.querySelector('.ks-floating-nav');
  const worlds = document.querySelectorAll('.ks-world');
  const firstWorld = document.querySelector('#ks-world-dessous');

  /* ----------------------------------------
     1) Smooth Scroll für World-Links
  ---------------------------------------- */
  navLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      const target = document.querySelector(targetId);

      if (!target) return;

      e.preventDefault();

      const headerOffset = 90;
      const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    });
  });

  /* ----------------------------------------
     2) Floating Navigator erst ab erster World zeigen
  ---------------------------------------- */
  function updateFloatingNav() {
    if (!floatingNav || !firstWorld || !worlds.length) return;

    const firstWorldRect = firstWorld.getBoundingClientRect();

    if (firstWorldRect.top > window.innerHeight * 0.6) {
      floatingNav.classList.remove('is-visible');
      floatingNav.style.pointerEvents = 'none';
      return;
    }

    floatingNav.classList.add('is-visible');
    floatingNav.style.pointerEvents = 'auto';
  }

  window.addEventListener('scroll', updateFloatingNav, { passive: true });
  window.addEventListener('resize', updateFloatingNav);

  updateFloatingNav();
});